<template>
  <router-view />
</template>

<script>
import { name as moduleName } from '@/modules/serviceProposalHistory/store';
import storeMixin, { unRegisterMixin } from 'utils/mixins/storeGenerator';

export default {
  name: 'ProposalHistoryWrapper',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName,
  }),
};
</script>
